import { render, staticRenderFns } from "./MPzhTable.vue?vue&type=template&id=0c2d52f4&scoped=true"
import script from "./MPzhTable.vue?vue&type=script&lang=js"
export * from "./MPzhTable.vue?vue&type=script&lang=js"
import style0 from "./MPzhTable.vue?vue&type=style&index=0&id=0c2d52f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2d52f4",
  null
  
)

export default component.exports